"use client";

import { useEffect, useRef } from "react";

export default function ScrollDepth() {
  const maxRef = useRef(0);
  const sent25 = useRef(false);
  const sent50 = useRef(false);
  const sent75 = useRef(false);
  const sent100 = useRef(false);

  useEffect(function setup() {
    function onScroll() {
      const el = document.documentElement;
      const scrollTop = el.scrollTop || document.body.scrollTop;
      const height = el.scrollHeight - el.clientHeight;
      if (height <= 0) return;
      const pct = Math.min(100, Math.floor((scrollTop / height) * 100));
      maxRef.current = Math.max(maxRef.current, pct);
      const send = (mark: number, ref: React.MutableRefObject<boolean>) => {
        if (!ref.current && maxRef.current >= mark) {
          ref.current = true;
          try {
            window.dispatchEvent(
              new CustomEvent("analytics", { detail: { event: "scroll_depth", value: mark } })
            );
          } catch {}
        }
      };
      send(25, sent25);
      send(50, sent50);
      send(75, sent75);
      send(100, sent100);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return null;
}
